import React, { useEffect } from 'react'
import { isAndroid, isIOS, isMobile } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import history from 'src/config/routes/history'
import images from 'src/config/images'
import useDocumentTitle from 'src/hooks/use-document-title'
import * as Css from './styles'

export default function MobileAccess() {
  const { t } = useTranslation()
  useDocumentTitle('web.mobile.header')

  useEffect(() => {
    if (!isMobile) {
      history.push('/')
    }
  }, [])

  return (
    <Css.Div>
      <Css.Logo alt="web.login.img.alt" src={images.logo} />
      <div>{t('web.mobile.info-page')}</div>
      <div>
        {isAndroid && (
          <a
            href="https://play.google.com/store/apps/details?id=com.toodo"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Css.Img
              alt="Download on Google Play"
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            />
          </a>
        )}
        {isIOS && (
          <a
            href="https://apps.apple.com/br/app/toodo-despesas-corporativas/id6443706468"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Css.Img
              alt="Download on the App Store"
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            />
          </a>
        )}
      </div>
    </Css.Div>
  )
}
